import { FC } from 'react';
import StatusIndicator, {
  StatusIndicatorProps,
} from '@amzn/awsui-components-core/status-indicator';
import { CampaignStatus } from 'src/@types/valueMatching/enums';

const STATUS_TYPE_MAP: Record<string, StatusIndicatorProps.Type> = {
  [CampaignStatus.ACTIVE]: 'success',
  [CampaignStatus.SCHEDULED]: 'pending',
  [CampaignStatus.CANCELLED]: 'error',
  [CampaignStatus.EXPIRED]: 'stopped',
  [CampaignStatus.PAUSED_FUNDS_DEPLETED]: 'warning',
  [CampaignStatus.OVERRIDDEN]: 'info',
};

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const type = STATUS_TYPE_MAP[status] || 'info';
  return <StatusIndicator type={type}>{status}</StatusIndicator>;
};

export default StatusBadge;
